import React, {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {useLocation} from 'react-router-dom'
import {KTSVG, toAbsoluteUrl} from '../../../../../../_metronic/helpers'

import {Formik, ErrorMessage, Field, Form} from 'formik'
import {StaffAccountSchema} from '../../../../../Utils/_helpers/ValidationSchema'
import {GeneralDataOFLoginUser} from '../../../../../Utils/Auth'
import {CreateStaffAccount, UpdateStaffAccount} from '../StaffAccountSlice/StaffAccountSlice'
import {getAccountIdList} from '../../../AllCellCastUser/UserListSlice/UserListSlice'

const CreateStaffAccountPopup = ({show, handleClose, data, filter}: any) => {
  const param: any = useLocation()
  const dispatch = useDispatch()

  const accountIdList = useSelector(getAccountIdList)
  const Role = GeneralDataOFLoginUser()?.role
  const isUserWhiteLabel = GeneralDataOFLoginUser()?.isWhiteLabelUser === true

  interface StaffAccoutForm {
    avatar: String
    email: String
    mobile: Number | String
    name: String
    password: String
    role: String
    notes: String
    editting: boolean
    accountId: String
  }

  const [staffAccoutDetail, setStaffAccountDetail] = useState<StaffAccoutForm>({
    avatar: toAbsoluteUrl('/media/avatars/blank.png'),
    email: '',
    mobile: '',
    name: '',
    password: '',
    role: '',
    notes: '',
    editting: false,
    accountId: GeneralDataOFLoginUser()?.accountId,
  })
  const [passwordType, setPasswordType] = useState({
    password: true,
  })

  useEffect(() => {
    setPasswordType({
      password: true,
    })
  }, [show])

  ////////////Different role for differet user to create sub account////////////////////////////////
  useEffect(() => {
    if (data) {
      setStaffAccountDetail({
        ...staffAccoutDetail,
        ...{
          avatar: data?.avatar,
          email: data?.email,
          mobile: data?.mobile,
          name: data?.name,
          password: data?.password,
          role: data?.role,
          notes: data?.notes,
          accountId: data?.accountId,
          editting: true,
        },
      })
    }
  }, [data])
  const SuperAdmin = [
    {
      label: 'StaffAccount',
      detail: 'Best for business owners and company administrators',
      value: 'staffAdmin',
    },
    {
      label: 'Account Manager',
      detail: 'Best for business owners and company administrators',
      value: 'accountManager',
    },
    {label: 'Sales', detail: 'Best for business owners and company administrators', value: 'sales'},
    {
      label: 'Support',
      detail: 'Best for business owners and company administrators',
      value: 'supportStaff',
    },
    {
      label: 'Affiliate',
      detail: 'Best for business owners and company administrators',
      value: 'affiliate',
    },
  ]
  const StaffAdmin = [
    {
      label: 'Account Manager',
      detail: 'Best for business owners and company administrators',
      value: 'accountManager',
    },
    {label: 'Sales', detail: 'Best for business owners and company administrators', value: 'sales'},
    {
      label: 'Support',
      detail: 'Best for business owners and company administrators',
      value: 'supportStaff',
    },
    {
      label: 'Affiliate',
      detail: 'Best for business owners and company administrators',
      value: 'affiliate',
    },
  ]

  const WhiteLabelRoles = [
    {
      label: 'Account Manager',
      detail: 'Best for business owners and company administrators',
      value: 'accountManager',
    },
  ]

  return (
    <>
      <Modal
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-700px'
        className='vh-100'
        show={show}
        onHide={handleClose}
        scrollabel={'true'}
      >
        <div className='modal-header'>
          <h2>{`${
            param?.pathname.split('/').includes('staff-account') ? 'Create' : 'Update'
          } Staff Profile
           `}</h2>
          <div className='btn btn-icon btn-sm' onClick={handleClose}>
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
        </div>
        <div className='modal-body px-20 py-5 admin_list_modals'>
          <Formik
            initialValues={staffAccoutDetail}
            validationSchema={StaffAccountSchema}
            onSubmit={(values: any) => {
              values.name = values.name.replace(/^\s+|\s+$/g, '')

              delete values.editting
              const finalData = new FormData()
              for (var key in values) {
                finalData.append(key, values[key])
              }
              if (data) {
                dispatch(UpdateStaffAccount({_id: data?._id, data: finalData}))
                handleClose()
              } else {
                dispatch(CreateStaffAccount({filter, data: finalData}))
                handleClose()
              }
            }}
          >
            {({values, setFieldValue}: any) => (
              <Form>
                <div className='row mb-6'>
                  <label className='col-form-label fw-bold fs-6'>Avatar</label>
                  <div
                    className='image-input image-input-outline w-auto'
                    data-kt-image-input='true'
                  >
                    {typeof values.avatar !== 'object' && values?.avatar !== 'undefined' ? (
                      <img
                        src={
                          values.avatar == ''
                            ? toAbsoluteUrl('/media/avatars/blank.png')
                            : values.avatar
                        }
                        alt='poster'
                        width={125}
                        height={125}
                      />
                    ) : (
                      <img
                        src={URL.createObjectURL(values.avatar)}
                        alt='poster'
                        width={125}
                        height={125}
                      />
                    )}

                    <label
                      className='btn btn-icon btn-circle btn-color btn-active-color-primary w-25px h-25px bg-body shadow'
                      data-kt-image-input-action='change'
                      data-bs-toggle='tooltip'
                      data-bs-dismiss='click'
                      title='Change avatar'
                    >
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='16'
                        height='16'
                        fill='currentColor'
                        className='bi bi-pencil-fill'
                        viewBox='0 0 16 16'
                      >
                        <path d='M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z' />
                      </svg>
                      <input
                        type='file'
                        name='avatar'
                        onChange={(event: any) => setFieldValue('avatar', event?.target.files[0])}
                        accept='.png, .jpg, .jpeg'
                      />
                    </label>

                    <span
                      className='btn btn-icon btn-circle btn-color btn-active-color-primary w-25px h-25px bg-body shadow'
                      data-kt-image-input-action='remove'
                      data-bs-toggle='tooltip'
                      data-bs-dismiss='click'
                      title='Remove avatar'
                      onClick={(event: any) => setFieldValue('avatar', '')}
                    >
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='25'
                        height='25'
                        fill='currentColor'
                        className='bi bi-x'
                        viewBox='0 0 16 16'
                      >
                        <path d='M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z' />
                      </svg>
                    </span>
                  </div>
                  {/* </div> */}
                </div>

                <ErrorMessage name='avatar'>
                  {(msg: string) => <span className='text-danger'>{msg}</span>}
                </ErrorMessage>
                <label className='col-form-label required fw-bold fs-6' htmlFor='fullName-staff'>
                  Full Name
                </label>
                <Field
                  id={'fullName-staff'}
                  className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                  name='name'
                  type='text'
                />

                <ErrorMessage name='name'>
                  {(msg: string) => <span className='text-danger'>{msg}</span>}
                </ErrorMessage>

                <div className='row'>
                  <div className='col-lg-6'>
                    <label className='col-form-label required fw-bold fs-6' htmlFor='email-staff'>
                      Email
                    </label>
                    <Field
                      id={'email-staff'}
                      className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                      name='email'
                      type='text'
                    />

                    <ErrorMessage name='email'>
                      {(msg: string) => <span className='text-danger'>{msg}</span>}
                    </ErrorMessage>
                  </div>
                  <div className='col-lg-6'>
                    <label className='col-form-label required fw-bold fs-6' htmlFor='mobile-staff'>
                      Phone
                    </label>
                    <Field
                      id={'mobile-staff'}
                      className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                      name='mobile'
                      type='text'
                    />

                    <ErrorMessage name='mobile'>
                      {(msg: string) => <span className='text-danger'>{msg}</span>}
                    </ErrorMessage>
                  </div>
                </div>
                {!values.editting && (
                  <>
                    <label
                      className='col-form-label required fw-bold fs-6'
                      htmlFor='password-staff'
                    >
                      Password
                    </label>
                    <div className='password-wrap'>
                      <Field
                        id={'password-staff'}
                        className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                        name='password'
                        type={passwordType.password ? 'password' : 'text'}
                      />
                      <span
                        className='svg-icon svg-icon-3'
                        onClick={() => {
                          setPasswordType({...passwordType, password: !passwordType.password})
                        }}
                      >
                        {passwordType.password ? (
                          <i className='bi bi-eye-fill'></i>
                        ) : (
                          <i className='bi bi-eye-slash-fill'></i>
                        )}
                      </span>
                    </div>
                  </>
                )}

                <ErrorMessage name='password'>
                  {(msg: string) => <span className='text-danger'>{msg}</span>}
                </ErrorMessage>

                {GeneralDataOFLoginUser()?.isWhiteLabelUser === false && (
                  <>
                    <label className='col-form-label required fw-bold fs-6'>Account ID</label>
                    <Field
                      as='select'
                      name='accountId'
                      className='form-select form-select-solid form-select-lg mb-3'
                    >
                      <option value={''}>Select</option>
                      {accountIdList?.map((key: any, index: any) => {
                        return (
                          <option key={index} value={key?._id}>
                            {key?.companyName}
                          </option>
                        )
                      })}
                    </Field>
                  </>
                )}

                <label
                  className='col-form-label required fw-bold fs-6'
                  htmlFor='whiteLabelSubdomain-staff'
                >
                  Role
                </label>
                {isUserWhiteLabel ||
                  (values.accountId !== '6405bca175a3b3abaa00715d' && (
                    <>
                      {WhiteLabelRoles?.map((key: any, index: any) => (
                        <div key={index}>
                          <div className='fv-row'>
                            <div className='form-check form-check-custom form-check-solid align-items-center'>
                              <input
                                className='form-check-input'
                                type='radio'
                                value={key.value}
                                name='role'
                                checked={values?.role == key.value}
                                onChange={(event: any) => {
                                  setFieldValue('role', event?.target.value)
                                }}
                              />
                              <label
                                className='form-check-label'
                                htmlFor='kt_modal_update_role_option_0'
                              >
                                <div className='fw-bolder card-label fs-5 '>{key.label}</div>
                                <div className='text-gray-600'>{key.detail}</div>
                              </label>
                            </div>
                          </div>
                          <div className='separator separator-dashed my-5'></div>
                        </div>
                      ))}
                    </>
                  ))}

                {/* {accountIdList?.find((key: any) => key?._id === values?.accountId)?.companyName !==
                  'cellcast' && (
                  <>
                    {WhiteLabelRoles?.map((key: any, index: any) => (
                      <div key={index}>
                        <div className='fv-row'>
                          <div className='form-check form-check-custom form-check-solid align-items-center'>
                            <input
                              className='form-check-input'
                              type='radio'
                              value={key.value}
                              name='role'
                              checked={values?.role == key.value}
                              onChange={(event: any) => {
                                setFieldValue('role', event?.target.value)
                              }}
                            />
                            <label
                              className='form-check-label'
                              htmlFor='kt_modal_update_role_option_0'
                            >
                              <div className='fw-bolder card-label fs-5 '>{key.label}</div>
                              <div className='text-gray-600'>{key.detail}</div>
                            </label>
                          </div>
                        </div>
                        <div className='separator separator-dashed my-5'></div>
                      </div>
                    ))}
                  </>
                )} */}

                {/* IF SUPER ADMIN LOGIN */}

                {accountIdList?.find((key: any) => key?._id === values?.accountId)?.companyName ==
                  'cellcast' && (
                  <>
                    {(Role == 'superAdmin' || Role == 'subAdmin' ? SuperAdmin : StaffAdmin)?.map(
                      (key: any, index: any) => (
                        <div key={index}>
                          <div className='fv-row'>
                            <div className='form-check form-check-custom form-check-solid align-items-center'>
                              <input
                                className='form-check-input'
                                type='radio'
                                value={key.value}
                                name='role'
                                checked={values?.role == key.value}
                                onChange={(event: any) => {
                                  setFieldValue('role', event?.target.value)
                                }}
                              />
                              <label
                                className='form-check-label'
                                htmlFor='kt_modal_update_role_option_0'
                              >
                                <div className='fw-bolder card-label fs-5 '>{key.label}</div>
                                <div className='text-gray-600'>{key.detail}</div>
                              </label>
                            </div>
                          </div>
                          <div className='separator separator-dashed my-5'></div>
                        </div>
                      )
                    )}
                  </>
                )}

                <ErrorMessage name='role'>
                  {(msg: string) => <span className='text-danger'>{msg}</span>}
                </ErrorMessage>

                <div className='modal-footer d-flex justify-content-center'>
                  <div id='kt_drawer_chat_close'>
                    <button
                      className='btn btn-sm btn-light fw-500 text-primary text-hover-white bg-white btn-active-primary w-100px p-3 border border-primary'
                      type='button'
                      onClick={handleClose}
                    >
                      Cancel
                    </button>
                  </div>

                  <button type='submit' className='btn btn-primary ml-2'>
                    Save
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>
    </>
  )
}

export default React.memo(CreateStaffAccountPopup)
